import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/OnboardingSlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.onboarding || initialState;

export const selectFollowedCompanies = createSelector(
  [selectDomain],
  (state) => state.companiesFollowed,
);

export const selectRecommendedCompanies = createSelector(
  [selectDomain],
  (state) => state.recommendedCompanies,
);
export const selectRecommendedCompaniesLoading = createSelector(
  [selectDomain],
  (state) => state.recommendedCompaniesLoading,
);

export const selectPersonId = createSelector(
  [selectDomain],
  (state) => state.personId,
);

export const selectFollowedPeople = createSelector(
  [selectDomain],
  (state) => state.peopleFollowed,
);
export const selectRecommendedPeople = createSelector(
  [selectDomain],
  (state) => state.recommendedPeople,
);
export const selectRecommendedPeopleLoading = createSelector(
  [selectDomain],
  (state) => state.recommendedPeopleLoading,
);
export const selectFollowedCompaniesCount = createSelector(
  [selectDomain],
  (state) => state.followedCompaniesCount,
);
export const selectOnboardingCompanyPopup = createSelector(
  [selectDomain],
  (state) => state.addCompanyPopup,
);
export const selectDailyIqToaster = createSelector(
  [selectDomain],
  (state) => state.successToaster,
);
